import { useEffect } from 'react';

const TRESSLE_SCRIPT_SRC = 'https://cdn.tressle.com/js/tressle-latest.min.js';

function Tressle() {
  useEffect(() => {
    function _init() {
      window.tressle = window.tressle || [];
      window.tressle.load = (e, s) => {
        window.tressle.key = e;
        window.tressle.options = s;
        const r = document.createElement('script');
        r.async = !0;
        r.src = TRESSLE_SCRIPT_SRC;
        const t = document.getElementsByTagName('script')[0];
        t.parentNode.insertBefore(r, t);
      };

      window.tressle.load('key_1e3Cvu8YpEOH0A8lPTFChnI1Kks', {});
    }

    if (window.tressle && window.tressle.init) {
      window.tressle.init();
    } else {
      _init();
    }
  }, []);
  return null;
}

export default Tressle;
